import React from 'react';

import './Sidebar.css';

const Sidebar = ({ children }) => {

    const [open, setOpen] = React.useState(true);

    /* Set the width of the side navigation to 0 and the left margin of the page content to 0 */
    const getWidth = () => {
        if (open) return '300px';
        return "0";
    }

    return <React.Fragment>
        {!open && <div className="openbtn" onClick={() => setOpen(true)}>&#8250;</div> }
        <div id="mySidenav" className="sidenav" style={{width: getWidth()}}>
            { <div className="closebtn" onClick={() => setOpen(false)}>&#8249;</div> }
            
            <div className="sidebarDetails">
                {children}
            </div>

        </div>
    </React.Fragment>
}


export default Sidebar;
